const prefix = "sealSystem";
import http from "../http";

import common from "./common";

const options = {
  prefix,
  http
};

export default {
  common: common(options)
};



// WEBPACK FOOTER //
// ./src/server/api/index.js